import styled from 'styled-components'

export const Container = styled.div`
    box-sizing: border-box;
    padding: 6px 8px 0 8px;
`
